import useBackend from "@/composition/useBackend";
import {replace} from "@/phrase-lookup-factory";

export default function () {

  const backendApi = useBackend();

  const browserLanguages = [document.documentElement.lang, ...navigator.languages.map(r => r.substring(0, 2))];

  function get(context: string, template: string) {
    return replace(backendApi.phrases.get([context], template, browserLanguages));  
  }
  
  return {
    node: (nodeName: string) => {
      return get(`graph.${nodeName}`, capitalize(nodeName));
    },
    edge: (parentNode: string, edgeName: string) => {
      return get(`graph.${parentNode}.edges`, capitalize(
        edgeName
        .replaceAll(/_(\w)/g, (match) => ' ' + match.charAt(1).toUpperCase())
      ));
    },
    field: (nodeName: string, field: string) => {
      if (!nodeName || nodeName === 'undefined' || nodeName === 'root') {
        throw new Error('Invalid node name');
      }
      const contextKey = `graph.${nodeName}.fields`;

      if (field.indexOf('->') > -1) {
        const parts = field.split('->');
        let mapField = parts[1];
        mapField = mapField.substring(1, mapField.length - 1);
        field = parts[0] + '.' + mapField;
      }
      field = field.replaceAll(/(:\w)/g, (match) => match.charAt(0) + ' ' + match.charAt(1).toUpperCase());

      return get(contextKey, capitalize(field));
    },
  }

}

function capitalize(input: string) {
  input = input.replace(/((?<![\.\s])[A-Z])/g, ' $1');
  input = input.replace(/(\.\w)/g, (match) => '.' + match.charAt(1).toUpperCase());
  input = input.charAt(0).toUpperCase() + input.slice(1);
  return input;
}